import { useOrderSet, useWorkItemIdForOrder } from "@repo/data-store";
import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { useFloatingPromptActions, useFloatingPromptOpen } from "@/app/command-palette/use-floating-prompt-store";

export function useFloatingPrompt() {
  const open = useFloatingPromptOpen();
  const { selectTask } = useFloatingPromptActions();

  // Extract taskId from route params when on /tasks/$taskId
  const taskIdFromRoute = useRouterState({
    select: (s) => {
      const match = s.matches.find((m) => m.routeId === "/tasks/$taskId");
      return (match?.params as { taskId?: string })?.taskId ?? null;
    },
  });

  // Resolve charting task from encounter protocol when on visit page
  const visitParams = useRouterState({
    select: (s) => {
      const match = s.matches.find((m) => m.routeId === "/patients/$patientId/_layout/visits/$visitId");
      if (!match) return null;
      return match.params as { patientId: string; visitId: string };
    },
  });

  const orderSet = useOrderSet({ visitId: visitParams?.visitId });
  const chartingTaskId = useWorkItemIdForOrder(orderSet?.orderSetId, orderSet?.currentOrder?.orderId);

  // Auto-select: task detail route > visit charting task
  const autoTaskId = taskIdFromRoute ?? chartingTaskId;

  useEffect(() => {
    if (open && autoTaskId) {
      selectTask(autoTaskId);
    }
  }, [open, autoTaskId, selectTask]);

  return { open };
}
